module.exports = __webpack_public_path__ + "static/media/logo_winter.ed6e5299.png";